<template>
    <div @click="changeState" class="switch_wrapper">
        <div :class="state === SWITCH_STATE.ON ? 'switch_on' : 'switch_off'" class="move_wrapper"></div>
        <div :class="state === SWITCH_STATE.ON ? 'active' : ''" class="swtich_text">ON</div>
        <div :class="state === SWITCH_STATE.OFF ? 'active' : ''" class="swtich_text">OFF</div>
    </div>
</template>

<script>
const SWITCH_STATE = {
    ON: 1,
    OFF: 0
}

export default {
    name: 'CommonSwitch',
    props: {
        completeAction: {
            type: Function,
            default: () => {}
        },
        initState : {
            type : Number,
            default : SWITCH_STATE.ON
        }
    },
    watch : {
         initState(){
             this.state = this.initState;
         }
    },
    data() {
        return {
            state: SWITCH_STATE.ON,
            SWITCH_STATE: SWITCH_STATE
        }
    },
    methods: {
        changeState() {
            if (this.state === SWITCH_STATE.ON) {
                this.state = SWITCH_STATE.OFF
                this.completeAction(this.state)
            } else {
                this.state = SWITCH_STATE.ON
                this.completeAction(this.state)
            }
        }
    },
    created(){
        this.state = this.initState
    }
}
</script>

<style scoped>
.switch_wrapper {
    width: 100px; 
    background-color: #fff; 
    border-radius: 24px; 
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2); 
    display: flex; 
    padding: 10px 0;
    position: relative;
}

.swtich_text {
    font-weight: 700; 
    flex: 1; 
    display: flex; 
    justify-content: center;
    padding: relative;
    z-index: 1;
    color: var(--color-main);
    transition: all 0.2s;
}

.active {
    color: #fff;
}

.move_wrapper {
    position: absolute; 
    background-color: var(--color-main); 
    width: 55%; 
    height: 100%; 
    border-radius: 24px; 
    top: 0;
    transition: all 0.2s;
}

.switch_off {
    transform: translateX(85%);
}

.switch_on {
    transform: translateX(0);
}
</style>